import { Table } from "@components/Table";
import { columns } from "./tableColumns";

export const DownloadHistory = ({ downloadHistory }) => (
  <section className="mt24">
    <Table
      data={downloadHistory}
      columns={columns}
      title="Pobrania dokumentacji"
      empty={{ title: "Nikt jeszcze nie pobrał dokumentacji" }}
    />
  </section>
);
